import React from "react";
import BulkUploadFile from "../../components/BulkUploadFile";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as SlotsPropertiesActions from "../../store/actions/Slots";

const instructions = [
  "Gig Cancellation Fee For Drivers will be exempted",
  "Gig Cancellation Fee if exist for the given slot capacity and driver, then it will be reverted",
  "Reverted: Reverting a gig cancellation fee will revert only the pass cancellation fees. Future cancellations will be charged",
  "Exempted: Exempting a gig cancellation fee will exempt both past as well as the future cancellations",
  "We can revert/exempted a slot for cancellation fee  by passing the exemptions REVERTED/EXEMPTED",
  "Please provide data as per the format in the sample file.",
  "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
];

const DriverSlotsCancellationFeeExemption = ({
  getDriverGigsCancellationFeeExemptionUrl,
}) => {
  return (
    <BulkUploadFile
      instructions={instructions}
      btnDataTestID="driverSlotsCancellationFeeExemption"
      uploadUrl="/driver-shift/slot/bulk-driver-slot-cancellation-fee-exempted/ack"
      sampleURL="/sample/bulk_driver_slot_cancellation_fee_exempted.csv"
      id="driverSlotsCancellationFeeExemptionModal"
      sendExtraAck={true}
      keyName="callback_key"
      heading="Gigs Cancellation Fee Exemption upload (Driver)"
      getUploadUrl={getDriverGigsCancellationFeeExemptionUrl}
    />
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getDriverGigsCancellationFeeExemptionUrl: bindActionCreators(
      SlotsPropertiesActions.getDriverGigsCancellationFeeExemptionUrl,
      dispatch
    ),
  };
}

export default connect(
  null,
  mapDispatchToProps
)(DriverSlotsCancellationFeeExemption);
